import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query VariationOriginalText($id: ID!) {
    originalVariation(id: $id) {
      id
      acCopyText
      score
    }
  }
`;

export const queryVariationOriginal = async (id) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: { id },
  });

  const data = getSingleProp(result.data);
  if (!data) {
    return null;
  }
  return {
    text: data.acCopyText,
    score: data.score,
  };
};
